import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";
import {
  withdraw,
  getRefUser,
  withdrawCommission
} from "service";

const Loading = () => {
  return (
    <span id="wave">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </span>
  );
};

const LoadingButton = ({ className }) => {
  return (
    <button className={className}>
      <div className="spinner-border spinner-border-sm" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </button>
  );
};

const Info = (props) => {
  const state = useSelector((state) => state);
  const [load, setLoad] = useState(true);
  const [treeView, setTreeView] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [dataUser, setDataUser] = useState({});


  // useEffect(() => {
  //   if (state.address_web3) {
  //     _getRefUser(state.address_web3);
  //   }
  // }, [state.address_web3]);

  useEffect(() => {
    _getRefUser();
    setInterval(() => {
      _getRefUser();
    }, 1000);
  }, []);

  const _getRefUser = async () => {
    let res = await getRefUser();

    if (!res) {
      return
    }
    setDataUser(res);
    // console.log(res);
    setLoad(false)
  }

  const onClaim = async () => {
    setLoading(true);
    let data = await withdrawCommission();
    // console.log(data);
    if (!data) {
      NotificationManager.error("Error", "Error", 10000);
    } else {
      NotificationManager.success("Withdraw Success", "Error", 10000);
    }

    setLoading(false);
  }

  return (
    <div className="site-main-content__home">
      <div className="container">
        <div className="col col-12 mb-3">
          <div className="block-item item-ocean-pools">
            <div className="block-item__wrap">
              <h2 className="block-item__title mb-4">User Info</h2>
              <div className="row">
                <div className="col-12 mb-3">
                  Address: {state.address_web3?.slice(0, 4)}...
                  {state.address_web3?.slice(-4)}
                </div>
                <div className="col-12 mb-3">
                  Refer By: {dataUser?.ref?.slice(0, 4)}...
                  {dataUser?.ref?.slice(-4)}
                </div>

                <div className="col-12 col-md-6 mt-3 mt-md-0">
                  <div className="mb demo_class">
                    Total Investment:{" "}
                    {!load ? (
                      (Number(dataUser?.amount) / 1e18 || 0).toFixed(2)
                    ) : (
                      <Loading />
                    )}
                  </div>

                  <div className="mt-2 mb demo_class">
                    Branch Sales:{" "}
                    {!load ? (
                      (Number(dataUser?.directSales) / 1e18 || 0).toFixed(2)
                    ) : (
                      <Loading />
                    )}
                  </div>

                </div>
                <div className="col-12 col-md-6 mt-md-0">

                  <div className="mb demo_class">
                    Compounding:{" "}
                    {!load ? (
                      (Number(dataUser?.compounding) / 1e18 || 0).toFixed(6)
                    ) : (
                      <Loading />
                    )}
                  </div>

                  <div className="mt-2 mb demo_class">
                    Received:{" "}
                    {!load ? (
                      (Number(state.user?.received) / 1e18 || 0).toFixed(6)
                    ) : (
                      <Loading />
                    )}
                  </div>

                  {loading ? (
                    <LoadingButton className="btn btn-primary" />
                  ) : (
                    <>
                      <button
                        className="btn btn-primary mt-3"
                        onClick={onClaim}
                      >
                        Claim
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info;
